import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import AdSense from 'react-adsense';
import { Helmet } from "react-helmet";
import { alert_error, alert_success } from "../../../AppContext";
import axios from 'axios';
const LivestreamViewer = () => {
    const codeSnippet_1 = `https://hust.media/link/load_system/add_link.php?apikey={api_key}&lienket={url}&chedo=14&mota={mota}`;
    const codeSnippet_2 = `[{"id":"5871","capdo":"11","service_name":"Level Zalo","url":"https:\/\/hust.media\/","view":"3","money":"0","verified":"1","note":"thanks users","createdate":"2024-08-31 23:21:20","status":"show","code":"https:\/\/hust.media\/vip\/UlvsTPLR725Z"},{"id":"5870","capdo":"12","service_name":"Level Reports","url":"https:\/\/hust.media","view":"2","money":"0","verified":"1","note":"thanks users","createdate":"2024-08-31 23:17:41","status":"show","code":"https:\/\/hust.media\/vip\/T3oqYkkMGfFl"}]`;
    const codeSnippet_3 = `F12 là ra hết =))`;
    function saochep(value) {
        alert_success("Đã sao chép");
        window.saochepnative(value);
    }
    return (
        <>
        <div className="mt-1 mx-2 ">
         <div className="mt-1 mx-2 mx-auto max-w-2xl">
         <form className="mt-1 add-form">
         <div className="form-control">
         <div className="text-base text-center">Tạo link</div>
           <div className="mb-2 bg-pink-200 px-2 py-1 rounded-lg relative">
               <div className="flex items-center justify-between ">
                   <div className="text-sm mb-1 text-gray-800 break-all">Get url</div>

                   <div className="flex space-x-1">
                       <button
                           type="button"
                           className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           onClick={() => saochep(codeSnippet_1)}
                       >
                           Copy
                       </button>
                       <a href="https://t.me/hustmedia" target="_blank" className="ml-auto">
                           <button
                               type="button"
                               className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           >
                               Support
                           </button>
                       </a>
                   </div>
               </div>
               <pre className="whitespace-pre-wrap text-gray-900">{codeSnippet_1}</pre>
           </div>
           <div className="text-base text-center">Lấy lịch sự link</div>
           <div className="mt-1 mb-2 bg-pink-200 px-2 py-1 rounded-lg relative">
               <div className="flex items-center justify-between ">
                   <div className="text-sm mb-1 text-gray-800 break-all">truy cập url https://hust.media/link/load_users/history_create.php?apikey=apikey&listtrang=1</div>

                   <div className="flex space-x-1">
                       <button
                           type="button"
                           className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           onClick={() => saochep(codeSnippet_2)}
                       >
                           Copy
                       </button>
                       <a href="https://t.me/hustmedia" target="_blank" className="ml-auto">
                           <button
                               type="button"
                               className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           >
                               Support
                           </button>
                       </a>
                   </div>
               </div>
               <pre className="whitespace-pre-wrap text-gray-900">{codeSnippet_2}</pre>
           </div>
           <div className="text-base text-center">Chuyên nghiệp</div>
           <div className="mt-1 mb-2 bg-gray-900 px-2 py-1 rounded-lg relative">
               <div className="flex items-center justify-between ">
                   <div className="text-sm mb-1 text-gray-400 break-all">App dùng apikey không dùng cookie</div>

                   <div className="flex space-x-1">
                       <button
                           type="button"
                           className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           onClick={() => saochep(codeSnippet_3)}
                       >
                           Copy
                       </button>
                       <a href="https://t.me/hustmedia" target="_blank" className="ml-auto">
                           <button
                               type="button"
                               className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                           >
                               Support
                           </button>
                       </a>
                   </div>
               </div>
               <pre className="whitespace-pre-wrap text-gray-300">{codeSnippet_3}</pre>
           </div>
           </div>
           </form>
           </div>  </div>
           <br/>
       </>
    );
};

export default LivestreamViewer;
